import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

export const outcomesApi = createApi({
  reducerPath: 'outcomesApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/projects/',
  }),
  endpoints: builder => ({
    // Fetch Outcomes by Segments IDs
    fetchSegmentOutcomes: builder.query({
      query: ({ projectId, productId, segmentIds = [] }) => ({
        url: `${projectId}/products/${productId}/outcomes/?segment=${segmentIds.join(',')}`,
      }),
    }),
  }),
});

export const { useFetchSegmentOutcomesQuery } = outcomesApi;
